import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageCheck"><Path d="M20 2H4V22H12.2573L9.25736 18.9997L13.5003 14.7574L15.2985 16.5558L20 11V2Z" fill="currentColor"/><Path d="M21.9084 14.8719L20.3719 13.5916L15.4328 19.5188L13.5001 17.5858L12.0858 18.9999L15.5672 22.4817L21.9084 14.8719Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageCheck;
